//simple regex to test for a valid email in frontend. Not bullet proof, backend should handle this properly
export const EMAIL_REGEXP = /^(\S+)@(\S+)\.\S{2,}$/;
// This is copied from API (src/config/default.config.ts). We can change it if needed
export const MIN_PASSWORD_LENGTH = 8;

export const NAME_REQUIRED = 'Name field is required';
export const EMAIL_REQUIRED = 'E-Mail field is required';
export const EMAIL_INVALID = 'E-Mail is invalid';
export const PASSWORD_REQUIRED = 'Password field is required';
export const PASSWORD_SHORT = 'Password is too short';

export const validateName = (value?: string | null): string | null => {
  if (!value) {
    return NAME_REQUIRED;
  }
  return null;
};
//NOTE: This function returns `truthy` when it is NOT a valid email
export const validateEmail = (value?: string | null): string | null => {
  if (!value) {
    return EMAIL_REQUIRED;
  }
  if (!EMAIL_REGEXP.test(value)) {
    return EMAIL_INVALID;
  }
  return null;
};

export const validatePassword = (value?: string | null): string | null => {
  if (!value) {
    return PASSWORD_REQUIRED;
  }
  if (value.length < MIN_PASSWORD_LENGTH) {
    return PASSWORD_SHORT;
  }

  return null;
};

export const validators = {
  name: validateName,
  email: validateEmail,
  password: validatePassword,
};
